import React from 'react';
import '../../App.css';
import Cards from '../Cards';
import HeroSection from '../HeroSectionServices'
import Hero from '../HeroServEn'
import HeroCorp from '../HeroCorp'
import Footer from '../../Footer/FooterEn';
import CorpServ from '../Services/CorpServEn'


function Services () {
    return (
        <div>
            <Hero/>
            <CorpServ/>
            <Footer/>
        </div>
    );
}


export default Services;
